module.exports = __webpack_public_path__ + "assets/icon-prom-deselected.84172980.svg";